import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Login } from "./components/Login";
import styles from "./index.css";
import { Navbar } from "./components/Navbar";
import { StudentApplyAdmission } from "./components/StudentApplyAdmission";
import Home from "./components/Home";
import Footer from "./components/footer";
import Profile from "./components/profile";
import { StudentNav } from "./components/studentNav";
import ChatBot from "./components/ChatBot";
import StudentPerformance from "./components/StudentPerformance";
import Leaderboard from './components/Leaderboard';
import Pricing from './components/PricingPage';
import ContactUs from './components/ContactUs';

function App() {
    return (
        <BrowserRouter>
            <Navbar/>
            <Routes>
                <Route index element={<Home />} />
                <Route path="login" element={<Login />} />
                <Route path="pricing" element={<Pricing />} />
                <Route path="contact" element={<ContactUs />} />
                <Route path="apply_student_admission" element={<StudentApplyAdmission />} />
                <Route path="profile" element={<Profile />} />
                <Route path="studentnav" element={<StudentNav />} />
                <Route path="chat" element={<ChatBot />} />
                <Route path="leaderboard" element={<Leaderboard />} />
                <Route path="student-performance" element={<StudentPerformance />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    );
}

export default App;